// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import loginData from './login-data';
import formTemplete from "./form-template"
import rolesManagement from './roles-management';
import templateType from './template-type';
import subAdminDropdown from './sub-admin-dropdown';
import phaseReducer from './phase-reducer';
import bmrSliceGroup from '../../bmr/slices';
import operation from './operation'
// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ menu, loginData, formTemplete, rolesManagement, templateType, subAdminDropdown, phaseReducer, operation, ...bmrSliceGroup });

export default reducers;
